import { useEffect } from 'react';

export default function SupportChatbot({ enabled }) {
    useEffect(() => {
        if (!enabled) return;
        if (window.vsid) return;

        window.vsid = "ci218168094a376";
        (function() { 
            var vsjs = document.createElement('script'); 
            vsjs.type = 'text/javascript'; 
            vsjs.async = true; 
            vsjs.setAttribute('defer', 'defer');
            vsjs.src = 'https://www.virtualspirits.co.il/vsa/chat.js';
            var s = document.getElementsByTagName('script')[0]; 
            s.parentNode.insertBefore(vsjs, s);
        })();
    }, [enabled]);

    return null;
}
